var velms = document.querySelectorAll("[id='video']");
//const video = document.getElementById('video');
for(let i = 0, c = velms.length;i<c;i++){
  const video = velms[i];
  if(video) {
    const desktop = video.dataset.video;
    const mobile = video.dataset.mobile;
  
    const unmute = document.getElementById('video-unmute');
    if(unmute){
      unmute.addEventListener('click',function(){
        const v = document.getElementById('video');
        v.muted = !v.muted;
        const vt = document.getElementById('video-text');
        if(v.muted){ vt.innerText = vt.dataset.unmute; }
        else{ vt.innerText = vt.dataset.mute; }
      })
    }
  
    function generateSource(target){
      const source = document.createElement("source");
      source.src = target;
      source.type = "video/mp4"
      return source
    }
    
    if(window.innerWidth <= 900 && mobile != null && mobile != ""){
      video.appendChild(generateSource(mobile))
    }else{
      video.appendChild(generateSource(desktop))
    }
      
    video.addEventListener("load",(event) => { event.target.play(); });
  }
}

